const createAltText = (str = '', preText = '') => {
  if (preText) {
    return `${preText} ${str?.replace(/_/gi, '-')}`;
  }
  return str?.replace(/_/gi, '-');
};

export {createAltText};
